import React, { memo } from "react";

const PriceItem = memo(function PriceItem({ item, onClickBuy, onClickSell }) {
  // فرمت اعداد به فارسی
  const formatPrice = (value) => {
    if (!value) return null;
    return Number(value).toLocaleString('fa-IR');
  };

  const formatPricePerGram = (value) => {
    if (!value) return null;
    return Number(value).toLocaleString('fa-IR');
  };

  return (
    <div className="ItemBlock">
      <div className="RowItem">
        {/* نام آیتم */}
        <p className="Item2 Bold cursor-pointer hover:text-blue-500 transition-colors">
          {item.title}
        </p>

        {/* دکمه خرید (اگر فعال باشد) */}
        {item.buy && item.valueBuy ? (
          <p 
            className="Item2 cursor-pointer hover:text-green-400 transition-colors"
            onClick={() => onClickBuy(item)} // ارسال آیتم و نوع خرید
            style={{ color: "#000" }}
          >
           {formatPrice(item.valueBuy)}
          </p>
        ) : (
          <span style={{ color: "#e74c3c", fontSize: "0.9em" }}>غیر فعال</span>
        )}

        {/* دکمه فروش (اگر فعال باشد) */}
        {item.sell && item.valueSell ? (
          <p 
            className="Item2 cursor-pointer "
            onClick={() => onClickSell(item)} // ارسال آیتم و نوع فروش
            style={{ color: "#000" }}
          >
           {formatPrice(item.valueSell)}
          </p>
        ) : (
          <span style={{ color: "#fff", fontSize: "0.9em" , backgroundColor: "#ccc" }}>غیر فعال</span>
        )}
      </div>

      {/* نرخ هر گرم */}
      <div style={{ display: "flex", gap: "20px", fontSize: "12px", marginTop: "-5px", justifyContent: "space-between" }}>
        {item.buy && item.valueBuyPerGram && (
          <p style={{ color: "#fff" }}>
            <span style={{ color: "#fff" }}>نرخ گرم (خرید):</span>{" "}
            {formatPricePerGram(item.valueBuyPerGram)} تومان
          </p>
        )}
        {item.sell && item.valueSellPerGram && (
          <p style={{ color: "#fff" }}>
            <span style={{ color: "#fff" }}>نرخ گرم (فروش):</span>{" "}
            {formatPricePerGram(item.valueSellPerGram)} تومان
          </p>
        )}
      </div>
    </div>
  );
});

export default PriceItem;